import React from "react";

function MLMScripts() {
  return (
    <>
      <div
        className="brand-style-two-area default-padding bg-theme text-light bg-cover"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-15.jpg)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Our MLM Scripts
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="brand-style-two-items">
                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Investment MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/01.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Binary MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/03.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Bitcoin MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/02.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Board MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/04.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Cryptocurrency MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/05.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Donation MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/05.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Ecommerce MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/05.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Direct Selling MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/05.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>

                <div className="brand-style-two-item wow fadeInUp">
                  <h5>Gaming MLM Script</h5>
                  <div className="info">
                    <div className="logo-icon">
                      <img
                        src="https://validthemes.net/site-template/robok/assets/img/logo/05.png"
                        alt="Image Not Found"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MLMScripts;
